<template>
  <div class="productpage page">
    <div class="columns">
      <div class="column">
        <div class="breadcrumb">
          <router-link to="/">KK</router-link> <i class="icon icon-chevron-right"></i>
          <router-link v-if="cats.main.slug!='' " :to="{ name: 'CategoriesPage', params: { q: cats.main.slug }}">{{cats.main.name}}</router-link> <i class="icon icon-chevron-right"></i>
          <router-link v-if="cats.main.slug!='' " :to="{ name: 'CategoryPage', params: { c: cats.main.slug, s: cats.sub.slug }}">{{cats.sub.name}}</router-link> <i class="icon icon-chevron-right"></i>
          <span>{{product.bez1}}</span>
        </div>
      </div>
    </div>
    <div class="columns flex valign-top wrap half">
      <div class="column">
        <div class="prod-img-container">
          <img class="prod-img" v-if="product.bild != '' && ImageExist( '/upload/product-images/' + product.bild ) " :src="'/upload/product-images/' + product.bild ">
          <img class="prod-img" v-else src="/upload/content/platzhalter.svg">
          <div class="banner">{{product.vari}} {{product.fmng}} {{product.me}} {{product.vpe}}</div>
        </div>
        <div class="p-bio p-detail" v-if=" product.bio.toLowerCase() == 'j' "><img src="/upload/labels/bio.jpg"></div>
        
      </div>
      <div class="column headline">
        <h1>{{product.bez1}}</h1>        
<!--         <h2>{{product.vari}} {{product.fmng}} {{product.me}} {{product.vpe}}</h2> -->
        <div class="product-info">

          <div class="p-vari p-detail" v-if="product.vari"><span class="label">Variation</span> {{product.vari}}</div>
          <div class="p-fmng p-detail"><span class="label">Füllmenge</span> {{product.fmng}} {{product.me}}</div>
          <div class="p-vpe p-detail"><span class="label">Verpackungseinheit</span> {{product.vpe}}</div>

<!--
          <div class="p-meta p-detail">
            <a v-on:click="love_it"><i :class=" 'icon icon-favourite ' + checkFav() "></i></a>
            
            <div class="intobasket">
             <textarea v-model="notes" placeholder="Notiz / Sonderwunsch?"></textarea>
            </div>
          </div>
-->
          
<!--
          <div class="p-meta p-detail">
            <div class="intobasket">
               <i class="icon icon-minus" v-on:click="minus"></i> <input type="number" v-model="amount"> <i class="icon icon-plus" v-on:click="plus"></i> 
               <a v-on:click="to_basket">
                  <i class="icon icon-basket"></i><span>In den Korb</span>
               </a>
            </div>
          </div>
-->

          <div class="p-detail" v-if=" crossproducts.length > 0">
            <h3>Variante/n</h3>
            <div class="crossproducts">
              <div class="crossproduct" v-for="(crossproduct, i) in crossproducts" :key="i">
              <router-link class="product-preview-link" :to="{ name: 'DetailPage', params: { pg: crossproduct.pg, artnr: crossproduct.artnr } }">
                <div :class=" 'prod-img-container ' + ( crossproduct.artnr == product.artnr ? 'active' : '' ) ">
                  <img v-if="crossproduct.bild != '' && ImageExist( '/upload/product-images/' + crossproduct.bild ) " :src=" '/upload/product-images/' + crossproduct.bild ">
                  <img class="placholder" v-else :src=" product.bio == 'J' ? '/upload/product-images/platzhalter_bio_bw.svg':'/upload/product-images/platzhalter_artikelohnefoto.svg' ">
                </div>
                <span class="link-label-product-preview">
                {{crossproduct.vari}} <br>{{crossproduct.fmng}} {{crossproduct.me}} {{crossproduct.vpe}}
                </span>
              </router-link>
            </div>
            </div>
          </div>

          <div class="p-info p-detail" v-if="product.info"><p>{{product.info}}</p></div>
        </div>
      </div>      
    </div>
    <div class="columns flex valign-top wrap half">
      
    </div>
  </div>
</template>
<script>
import categories     from '../data/categories.json';
import products       from '../data/etar2.json';
import productsinfo   from '../data/etais.json';
import productgroups  from '../data/etpgr.json';

export default {
    name: 'DetailPage',
    data: function(){
      return {
        cats: {
          main: { name: '', slug:''},
          sub: { name: '', slug:''}
        },
         product: {
            artnr: null,
            bez: '',
            bild: null,
            bio: null,
            bztg: null,
            einh: null,
            fmng: null,
            mc: null,
            me: null,
            pg: null,
            vari: null,
            vpe: null,
            info: ""
         },
         crossproducts: [],
/*
         loveIt: () => { 
           return this.$store.state.user.fav.filter( (favItem) => { return favItem.artnr == this.product.artnr }) 
           },
*/
         amount: 1,
         notes: null
      }
    },
    
    created: function(){
      //console.log(this.items);
      this.filterResults()
      //console.log(this.$store.state.user.fav.includes( this.product.artnr ));
      //console.log(this.product)
    },
    watch: {
    '$route.params.artnr': function (artnr) {
      this.filterResults()
      },
    },
    mounted: function() {
      //this.filterResults()
      this.getCategory()
    },
    computed: {
        user () {
            return this.$store.state.authentication.user
        },  
    },        
    methods: {
      getCategory(){
        var c = this.product.pg.substring(0, 4);
        categories.forEach( (maincat)=>{
          //console.log( maincat );
          var sub = maincat.contains.filter( (subcat) =>{ return subcat.pg == c })
          //console.log( sub );
          if(sub.length > 0) {
              this.cats = {
                  main: { name: maincat.name, slug: maincat.slug },
                  sub: { name: sub[0].name, slug: sub[0].slug }
                }
               //console.log( this.cats );
          }
        })
      },
      plus() {
        this.amount++
      },
      minus(){
        this.amount = this.amount - 1 < 1 ? 1 : --this.amount
      },
      checkFav(){
        if( !this.user ) return "";
         return ( this.$store.state.authentication.user.fav.filter( (favItem) => { return favItem.artnr == this.product.artnr }).length > 0 ? 'icon-favourite-full':'')
      },
      love_it(){
        
        var favSchonDrin = this.$store.state.authentication.user.fav.filter( (favItem) => { return favItem.artnr == this.product.artnr });
        if( favSchonDrin.length > 0 ) {
          var i = this.$store.state.authentication.user.fav.indexOf( this.product.artnr )
          this.$store.state.authentication.user.fav.splice(i,1);
        }
        else {
          this.$store.state.authentication.user.fav.push( this.product )
        }
        this.updateFavOnServer()        
        //this.loveIt = this.loveIt ? false : true;
        //this.$store.state.user.fav.push( this.artnr );
        //console.log('i love it');
        //console.log(this.$store.state.user.fav);
      },
      to_basket(){
        var self = this
        var schonDrin = this.$store.state.authentication.user.basket.filter( (basketItem) => { return basketItem.artnr == this.product.artnr });
        if( schonDrin.length < 1 ) {
          this.$store.state.authentication.user.basket.push({ 
            artnr: self.product.artnr, 
            count: this.amount,
            notes: this.notes,
            bez1: self.product.bez1,
            vari: self.product.vari,
            fmng: self.product.fmng,
            me: self.product.me,
            vpe: self.product.vpe,
            pg: self.product.pg,
            bild: self.product.bild,
            bio: self.product.bio,
            })
        } else {
          schonDrin[0].count = schonDrin[0].count + this.amount
        }
        
        this.updateCartOnServer()
        
      },
      
     updateCartOnServer(){
        const basket = this.user.basket;
        const { dispatch } = this.$store;
        dispatch('basket/update', { basket });
     },
     
     updateFavOnServer(){
        const fav = this.user.fav;
        const { dispatch } = this.$store;
        dispatch('fav/update', { fav });
        // use: this.updateFavOnServer()
     },
     
      
      
      ImageExist(url) {
           var img = new Image();
           img.src = url;
           //console.log(img.width);
           return true //img.width > 0;
        },
      filterResults(){
          var productdata = products.filter((item) => {
            return ( item.pg == this.$route.params.pg && item.artnr == this.$route.params.artnr ) 
          });
          if( productdata.length > 0) { 
            
            this.notes = null
            this.amount = 1
            
            this.product = productdata[0];

            var productinfo = productsinfo.filter((info) => { return ( info.id == this.$route.params.artnr || info.id == this.$route.params.pg ) });
            this.product.info = productinfo.length == 1 ? productinfo[0].is : "";
            
            this.crossproducts = products.filter((item) => {
              return ( item.pg == this.$route.params.pg  && item.fmng > 0 ) //&& item.artnr != this.$route.params.artnr
            });            
          } // if
      }
    }
}
</script>
<style >

  .productpage .columns.half .column:first-child { order: 2 !important }
  .productpage .columns.half .column:last-child { order: 1 !important }
  .productpage h1 { padding-top: 0.63333em; text-transform: none; }
  .productpage h2 { color: #00853e; }
  .productpage .label { display: inline-block; min-width: 10em; color: #00853e; }
  .productpage .product-info .p-detail { padding: 0.91333333em 0.91333333em 0.91333333em 0; border-top: 1px solid #ededef; color: #00853e; }
  .productpage .product-info .p-detail:last-child { border-bottom: 1px solid #ededef; }

  .productpage .p-bio { padding: 0.9333333em 0 0 0; }
  .productpage .p-bio img { display: inline-block; max-width: 6em; }
  .productpage .p-bio img { display: inline-block; max-width: 6em; }
  .productpage .prod-img-container { overflow: hidden; position: relative; }
  .productpage .prod-img-container.active { border: 1px solid #00853e; border-radius: 3px; overflow: hidden; }
  
  .productpage .prod-img { margin-top: 0; position: relative; z-index: 5; }
  .productpage .crossproducts { display: flex; flex-wrap: wrap; width: 100%; border: 0 solid green; position: relative; left: -0.4333333em; right: -0.4333333em }
  .productpage .crossproduct { flex: 1 1 25%; max-width: 25%; outline: 0 solid red; padding: 0.4333333em; }
  .productpage .product-preview-link { color: #00853e; text-decoration: none; }
  .productpage .product-preview-link span { display: block; padding: 0.222222em 0; }
  .productpage .product-preview-link img { transform: scale(1); transition: transform 0.2s; }
  .productpage .product-preview-link:hover img { transform: scale(1.03); }
  .productpage .placholder { opacity: 0.3; }
  .productpage .p-meta { display: flex; align-items: center; }
  .productpage .p-meta a { padding: 0 0.6333333em 0 0; display: block; }
  .productpage .intobasket { display: flex; padding: 0 0 0 0.633333em; align-items: center; width: 100%; }
  .productpage .intobasket input[type="number"] { width: 3em; text-align: right; margin: 0 0.2333333em }
  .productpage .intobasket textarea { flex: 1 1 100%; min-width: 100%; border: 1px solid #00853e; border-radius: 3px; padding: 0.43333333em; }
  .productpage .intobasket a { display: flex; border: 1px solid #00853e !important; border-radius: 3px; margin: 0 0 0 0.63333em; align-items: center; padding: 0.2333333em 0.6333333em; cursor: pointer; }
  .productpage .icon-basket { background: url(/img/icons-green/bag.svg) center center no-repeat; background-size: 115%; width: 1.6333rem; margin: 0 0.33333em 0 0; }
  .productpage .icon-chevron-right { background: url(/img/icons-green/chevron-right.svg) center center no-repeat; background-size: 115%; width: 1.6333rem; }
  
  .banner { position: absolute; background: #00853e; height: 3rem; z-index: 6; bottom: 4%; right: -20%; width: 140%; transform: rotate(-22deg); 
    color: #fff; font-size: 1.03333rem; text-align: center; line-height: 3rem; padding-left: 30%;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
  }
  
  .productpage .p-detail.p-fmng { font-weight: bold; }
  .productpage .p-detail.p-vari { font-weight: bold; }
  .productpage .p-detail.p-vpe { font-weight: bold; }
  .productpage .p-detail span { font-weight: normal !important; }
</style>
